// extracted by mini-css-extract-plugin
module.exports = {"container":"PromotionExpiredDialog_container__ttFmU","description":"PromotionExpiredDialog_description__y1LaB"};